// http://stackoverflow.com/questions/3217492/list-of-language-codes-in-yaml-or-json
// @author Phil Teare
// using Wikipedia data
module.exports = [
    {
        'code': 'ab',
        'name': 'Abkhaz'
    },
    {
        'code': 'aa',
        'name': 'Afar'
    },
    {
        'code': 'af',
        'name': 'Afrikaans'
    },
    {
        'code': 'ak',
        'name': 'Akan'
    },
    {
        'code': 'sq',
        'name': 'Albanian'
    },
    {
        'code': 'am',
        'name': 'Amharic'
    },
    {
        'code': 'ar',
        'name': 'Arabic'
    },
    {
        'code': 'an',
        'name': 'Aragonese'
    },
    {
        'code': 'hy',
        'name': 'Armenian'
    },
    {
        'code': 'as',
        'name': 'Assamese'
    },
    {
        'code': 'av',
        'name': 'Avaric'
    },
    {
        'code': 'ae',
        'name': 'Avestan'
    },
    {
        'code': 'ay',
        'name': 'Aymara'
    },
    {
        'code': 'az',
        'name': 'Azerbaijani'
    },
    {
        'code': 'bm',
        'name': 'Bambara'
    },
    {
        'code': 'ba',
        'name': 'Bashkir'
    },
    {
        'code': 'eu',
        'name': 'Basque'
    },
    {
        'code': 'be',
        'name': 'Belarusian'
    },
    {
        'code': 'bn',
        'name': 'Bengali'
    },
    {
        'code': 'bh',
        'name': 'Bihari'
    },
    {
        'code': 'bi',
        'name': 'Bislama'
    },
    {
        'code': 'bs',
        'name': 'Bosnian'
    },
    {
        'code': 'br',
        'name': 'Breton'
    },
    {
        'code': 'bg',
        'name': 'Bulgarian'
    },
    {
        'code': 'my',
        'name': 'Burmese'
    },
    {
        'code': 'ca',
        'name': 'Catalan; Valencian'
    },
    {
        'code': 'ch',
        'name': 'Chamorro'
    },
    {
        'code': 'ce',
        'name': 'Chechen'
    },
    {
        'code': 'ny',
        'name': 'Chichewa; Chewa; Nyanja'
    },
    {
        'code': 'zh',
        'name': 'Chinese'
    },
    {
        'code': 'cv',
        'name': 'Chuvash'
    },
    {
        'code': 'kw',
        'name': 'Cornish'
    },
    {
        'code': 'co',
        'name': 'Corsican'
    },
    {
        'code': 'cr',
        'name': 'Cree'
    },
    {
        'code': 'hr',
        'name': 'Croatian'
    },
    {
        'code': 'cs',
        'name': 'Czech'
    },
    {
        'code': 'da',
        'name': 'Danish'
    },
    {
        'code': 'dv',
        'name': 'Divehi; Dhivehi; Maldivian;'
    },
    {
        'code': 'nl',
        'name': 'Dutch'
    },
    {
        'code': 'en',
        'name': 'English'
    },
    {
        'code': 'eo',
        'name': 'Esperanto'
    },
    {
        'code': 'et',
        'name': 'Estonian'
    },
    {
        'code': 'ee',
        'name': 'Ewe'
    },
    {
        'code': 'fo',
        'name': 'Faroese'
    },
    {
        'code': 'fj',
        'name': 'Fijian'
    },
    {
        'code': 'fi',
        'name': 'Finnish'
    },
    {
        'code': 'fr',
        'name': 'French'
    },
    {
        'code': 'ff',
        'name': 'Fula; Fulah; Pulaar; Pular'
    },
    {
        'code': 'gl',
        'name': 'Galician'
    },
    {
        'code': 'ka',
        'name': 'Georgian'
    },
    {
        'code': 'de',
        'name': 'German'
    },
    {
        'code': 'el',
        'name': 'Greek, Modern'
    },
    {
        'code': 'gn',
        'name': 'Guaraní'
    },
    {
        'code': 'gu',
        'name': 'Gujarati'
    },
    {
        'code': 'ht',
        'name': 'Haitian; Haitian Creole'
    },
    {
        'code': 'ha',
        'name': 'Hausa'
    },
    {
        'code': 'he',
        'name': 'Hebrew (modern)'
    },
    {
        'code': 'hz',
        'name': 'Herero'
    },
    {
        'code': 'hi',
        'name': 'Hindi'
    },
    {
        'code': 'ho',
        'name': 'Hiri Motu'
    },
    {
        'code': 'hu',
        'name': 'Hungarian'
    },
    {
        'code': 'is',
        'name': 'Icelandic'
    },
    {
        'code': 'io',
        'name': 'Ido'
    },
    {
        'code': 'ig',
        'name': 'Igbo'
    },
    {
        'code': 'id',
        'name': 'Indonesian'
    },
    {
        'code': 'ia',
        'name': 'Interlingua'
    },
    {
        'code': 'ie',
        'name': 'Interlingue'
    },
    {
        'code': 'iu',
        'name': 'Inuktitut'
    },
    {
        'code': 'ik',
        'name': 'Inupiaq'
    },
    {
        'code': 'ga',
        'name': 'Irish'
    },
    {
        'code': 'it',
        'name': 'Italian'
    },
    {
        'code': 'ja',
        'name': 'Japanese'
    },
    {
        'code': 'jv',
        'name': 'Javanese'
    },
    {
        'code': 'kl',
        'name': 'Kalaallisut, Greenlandic'
    },
    {
        'code': 'kn',
        'name': 'Kannada'
    },
    {
        'code': 'kr',
        'name': 'Kanuri'
    },
    {
        'code': 'ks',
        'name': 'Kashmiri'
    },
    {
        'code': 'kk',
        'name': 'Kazakh'
    },
    {
        'code': 'km',
        'name': 'Khmer'
    },
    {
        'code': 'ki',
        'name': 'Kikuyu, Gikuyu'
    },
    {
        'code': 'rw',
        'name': 'Kinyarwanda'
    },
    {
        'code': 'ky',
        'name': 'Kirghiz, Kyrgyz'
    },
    {
        'code': 'rn',
        'name': 'Kirundi'
    },
    {
        'code': 'kv',
        'name': 'Komi'
    },
    {
        'code': 'kg',
        'name': 'Kongo'
    },
    {
        'code': 'ko',
        'name': 'Korean'
    },
    {
        'code': 'ku',
        'name': 'Kurdish'
    },
    {
        'code': 'kj',
        'name': 'Kwanyama, Kuanyama'
    },
    {
        'code': 'lo',
        'name': 'Lao'
    },
    {
        'code': 'la',
        'name': 'Latin'
    },
    {
        'code': 'lv',
        'name': 'Latvian'
    },
    {
        'code': 'li',
        'name': 'Limburgish, Limburgan, Limburger'
    },
    {
        'code': 'ln',
        'name': 'Lingala'
    },
    {
        'code': 'lt',
        'name': 'Lithuanian'
    },
    {
        'code': 'lu',
        'name': 'Luba-Katanga'
    },
    {
        'code': 'lg',
        'name': 'Luganda'
    },
    {
        'code': 'lb',
        'name': 'Luxembourgish, Letzeburgesch'
    },
    {
        'code': 'mk',
        'name': 'Macedonian'
    },
    {
        'code': 'mg',
        'name': 'Malagasy'
    },
    {
        'code': 'ms',
        'name': 'Malay'
    },
    {
        'code': 'ml',
        'name': 'Malayalam'
    },
    {
        'code': 'mt',
        'name': 'Maltese'
    },
    {
        'code': 'gv',
        'name': 'Manx'
    },
    {
        'code': 'mr',
        'name': 'Marathi (Marāṭhī)'
    },
    {
        'code': 'mh',
        'name': 'Marshallese'
    },
    {
        'code': 'mn',
        'name': 'Mongolian'
    },
    {
        'code': 'mi',
        'name': 'Māori'
    },
    {
        'code': 'na',
        'name': 'Nauru'
    },
    {
        'code': 'nv',
        'name': 'Navajo, Navaho'
    },
    {
        'code': 'ng',
        'name': 'Ndonga'
    },
    {
        'code': 'ne',
        'name': 'Nepali'
    },
    {
        'code': 'nd',
        'name': 'North Ndebele'
    },
    {
        'code': 'se',
        'name': 'Northern Sami'
    },
    {
        'code': 'no',
        'name': 'Norwegian'
    },
    {
        'code': 'nb',
        'name': 'Norwegian Bokmål'
    },
    {
        'code': 'nn',
        'name': 'Norwegian Nynorsk'
    },
    {
        'code': 'ii',
        'name': 'Nuosu'
    },
    {
        'code': 'oc',
        'name': 'Occitan'
    },
    {
        'code': 'oj',
        'name': 'Ojibwe, Ojibwa'
    },
    {
        'code': 'cu',
        'name': 'Old Church Slavonic, Church Slavic, Church Slavonic, Old Bulgarian, Old Slavonic'
    },
    {
        'code': 'or',
        'name': 'Oriya'
    },
    {
        'code': 'om',
        'name': 'Oromo'
    },
    {
        'code': 'os',
        'name': 'Ossetian, Ossetic'
    },
    {
        'code': 'pa',
        'name': 'Panjabi, Punjabi'
    },
    {
        'code': 'ps',
        'name': 'Pashto, Pushto'
    },
    {
        'code': 'fa',
        'name': 'Persian'
    },
    {
        'code': 'pl',
        'name': 'Polish'
    },
    {
        'code': 'pt',
        'name': 'Portuguese'
    },
    {
        'code': 'pi',
        'name': 'Pāli'
    },
    {
        'code': 'qu',
        'name': 'Quechua'
    },
    {
        'code': 'ro',
        'name': 'Romanian, Moldavian, Moldovan'
    },
    {
        'code': 'rm',
        'name': 'Romansh'
    },
    {
        'code': 'ru',
        'name': 'Russian'
    },
    {
        'code': 'sm',
        'name': 'Samoan'
    },
    {
        'code': 'sg',
        'name': 'Sango'
    },
    {
        'code': 'sa',
        'name': 'Sanskrit (Saṁskṛta)'
    },
    {
        'code': 'sc',
        'name': 'Sardinian'
    },
    {
        'code': 'gd',
        'name': 'Scottish Gaelic; Gaelic'
    },
    {
        'code': 'sr',
        'name': 'Serbian'
    },
    {
        'code': 'sn',
        'name': 'Shona'
    },
    {
        'code': 'sd',
        'name': 'Sindhi'
    },
    {
        'code': 'si',
        'name': 'Sinhala, Sinhalese'
    },
    {
        'code': 'sk',
        'name': 'Slovak'
    },
    {
        'code': 'sl',
        'name': 'Slovene'
    },
    {
        'code': 'so',
        'name': 'Somali'
    },
    {
        'code': 'nr',
        'name': 'South Ndebele'
    },
    {
        'code': 'st',
        'name': 'Southern Sotho'
    },
    {
        'code': 'es',
        'name': 'Spanish; Castilian'
    },
    {
        'code': 'su',
        'name': 'Sundanese'
    },
    {
        'code': 'sw',
        'name': 'Swahili'
    },
    {
        'code': 'ss',
        'name': 'Swati'
    },
    {
        'code': 'sv',
        'name': 'Swedish'
    },
    {
        'code': 'tl',
        'name': 'Tagalog'
    },
    {
        'code': 'ty',
        'name': 'Tahitian'
    },
    {
        'code': 'tg',
        'name': 'Tajik'
    },
    {
        'code': 'ta',
        'name': 'Tamil'
    },
    {
        'code': 'tt',
        'name': 'Tatar'
    },
    {
        'code': 'te',
        'name': 'Telugu'
    },
    {
        'code': 'th',
        'name': 'Thai'
    },
    {
        'code': 'bo',
        'name': 'Tibetan Standard, Tibetan, Central'
    },
    {
        'code': 'ti',
        'name': 'Tigrinya'
    },
    {
        'code': 'to',
        'name': 'Tonga (Tonga Islands)'
    },
    {
        'code': 'ts',
        'name': 'Tsonga'
    },
    {
        'code': 'tn',
        'name': 'Tswana'
    },
    {
        'code': 'tr',
        'name': 'Turkish'
    },
    {
        'code': 'tk',
        'name': 'Turkmen'
    },
    {
        'code': 'tw',
        'name': 'Twi'
    },
    {
        'code': 'ug',
        'name': 'Uighur, Uyghur'
    },
    {
        'code': 'uk',
        'name': 'Ukrainian'
    },
    {
        'code': 'ur',
        'name': 'Urdu'
    },
    {
        'code': 'uz',
        'name': 'Uzbek'
    },
    {
        'code': 've',
        'name': 'Venda'
    },
    {
        'code': 'vi',
        'name': 'Vietnamese'
    },
    {
        'code': 'vo',
        'name': 'Volapük'
    },
    {
        'code': 'wa',
        'name': 'Walloon'
    },
    {
        'code': 'cy',
        'name': 'Welsh'
    },
    {
        'code': 'fy',
        'name': 'Western Frisian'
    },
    {
        'code': 'wo',
        'name': 'Wolof'
    },
    {
        'code': 'xh',
        'name': 'Xhosa'
    },
    {
        'code': 'yi',
        'name': 'Yiddish'
    },
    {
        'code': 'yo',
        'name': 'Yoruba'
    },
    {
        'code': 'za',
        'name': 'Zhuang, Chuang'
    }
];
